










import Vue from "vue";
import iwInputCheckbox from "@/encoding/components/buildingBlocks/InputCheckbox.vue";

export default Vue.extend({
    components: {
        iwInputCheckbox: iwInputCheckbox,
    },

    data: function () {
        return {
            pathInStore: "property.privateEquipment.hasInternet",
        };
    },

    computed: {
        isDisplayed: function(): boolean {
            return ["HOUSE","OFFICE","INDUSTRY","COMMERCIAL","APARTMENT","OTHER", "HOMES_TO_BUILD"].indexOf(this.getPropertyType()) !== - 1;
        },

        hasInternet: {
            get: function(): boolean {
                return this.$store.getters["FormModule/getValue"](this.pathInStore);
            },

            set: function(value: boolean) {
                this.$store.dispatch("FormModule/addValue", {
                    path: this.pathInStore,
                    value: value
                });
            },
        },
    },
});
